var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"header-box"},[_c('navbar')],1),_vm._v(" "),_c('div',{staticClass:"wrapper-bottom"},[_c('sidebar'),_vm._v(" "),_c('div',{staticClass:"router-box"},[_c('div',{staticClass:"router-view"},[_c('router-view')],1)])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6065031e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage.vue
// module id = null
// module chunks = 